import api from "./api";
import { getStoredUser, getStoredClientId } from "../utils/tokenUtils";
import { getClientId } from "../utils/utils";

/**
 * Template service for managing test case templates
 */
export const templateService = {
  /**
   * Get all templates
   */
  getTemplates: async (filters = {}) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...filters,
      client_id: filters.client_id || storedClientId || getClientId(),
    };
    const response = await api.post("api/templates/list", payload);
    return response.data;
  },

  /**
   * Get template by ID
   */
  getTemplateById: async (templateId) => {
    const user = getStoredUser();
    const response = await api.post("api/templates/get", {
      template_id: templateId,
      client_id: getClientId(),
    });
    return response.data;
  },

  /**
   * Create template
   */
  createTemplate: async (templateData) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      ...templateData,
      client_id: templateData.client_id || storedClientId || getClientId(),
    };
    const response = await api.post("api/templates/create", payload);
    return response.data;
  },

  /**
   * Update template
   */
  updateTemplate: async (templateId, updates) => {
    const user = getStoredUser();
    const response = await api.post("api/templates/update", {
      template_id: templateId,
      ...updates,
      client_id: updates.client_id || getClientId(),
    });
    return response.data;
  },

  /**
   * Delete template
   */
  deleteTemplate: async (templateId) => {
    const user = getStoredUser();
    const response = await api.post("api/templates/delete", {
      template_id: templateId,
      client_id: getClientId(),
    });
    return response.data;
  },

  /**
   * Clone template
   */
  cloneTemplate: async (templateId, name) => {
    const user = getStoredUser();
    const response = await api.post("api/templates/clone", {
      template_id: templateId,
      name,
      client_id: getClientId(),
    });
    return response.data;
  },

  /**
   * Initialize default template for client
   */
  initializeDefaultTemplate: async () => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      client_id: storedClientId || getClientId(),
    };
    const response = await api.post("api/templates/initialize", payload);
    return response.data;
  },

  /**
   * Assign/unassign template to/from projects
   */
  assignTemplateToProjects: async (
    templateId,
    projectIds,
    action = "assign",
  ) => {
    const user = getStoredUser();
    const storedClientId = getStoredClientId();
    const payload = {
      template_id: templateId,
      project_ids: Array.isArray(projectIds) ? projectIds : [projectIds],
      action: action,
      client_id: storedClientId || getClientId(),
    };
    const response = await api.post("api/templates/assign", payload);
    return response.data;
  },
};

export default templateService;
